module.exports = __webpack_public_path__ + "img/horizontal_3_7_8011.12e2d59b.png";